import React from 'react';
import styled from 'styled-components';

interface IIncident {
  color: string;
  name?: string;
  width?: string;
  smallIcon?: boolean;
  type?: number;
  ellipsedText?: boolean;
  noIcon?: boolean;
};

const Incident = styled.div<{width?: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({width}) => width ? width : '24%'};
`;

const IncidentIcon = styled.div<{smallIcon?: boolean}>`
  width: ${({smallIcon}) => smallIcon ? '8px' : '10px'};
  height: ${({smallIcon}) => smallIcon ? '8px' : '10px'};
  min-width: ${({smallIcon}) => smallIcon ? '8px' : '10px'};
  min-height: ${({smallIcon}) => smallIcon ? '8px' : '10px'};
  border-radius: 50%;
  margin-right: ${({smallIcon}) => smallIcon ? '4px' : '8px'};
`;

const IncidentName = styled.div<{ellipsed?: boolean}>`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${({ellipsed}) => ellipsed ? 'nowrap' : 'normal'};
`;

export const IncidentType: React.FC<IIncident> = ({
  color,
  name,
  width,
  smallIcon,
  ellipsedText,
  noIcon,
  children,
}) => (
  <Incident width={width}>
    {!noIcon && <IncidentIcon style={{backgroundColor: color}} smallIcon={smallIcon}/>}
    <IncidentName ellipsed={ellipsedText}>
      {name ? name : children}
    </IncidentName>
  </Incident>
  );
